import React from 'react'

import { TextField ,Grid, Typography} from "@mui/material"
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import BooleanFilter from '../../core/form/BooleanFilter';
import { useSelector, useDispatch } from 'react-redux';
import { setPharmaorderFilterCriteria } from 'store/slice/PharmaSlice';

export default function PharmaorderFilterCriteria() {
    const dispatch = useDispatch();
    const {filterCriteria} = useSelector((state)=>state.pharmaslice.pharmaorderDashboard);
        
    const {partyList} = useSelector((state)=>state.pharmaslice);
    
const updateExecutivenameCriteria = (executivename) =>{
        dispatch(setPharmaorderFilterCriteria(
            {
                ...filterCriteria,
                executivename:executivename
        }))
    }
const updatePartynameCriteria = (partyname) =>{
        dispatch(setPharmaorderFilterCriteria(
            {
                ...filterCriteria,
                partyname:partyname
        }))
    }
const updateOrderidCriteria = (orderid) =>{
        dispatch(setPharmaorderFilterCriteria(
            {
                ...filterCriteria,
                orderid:orderid
        }))
    }
const updateOrderstatusCriteria = (orderstatus) =>{
        dispatch(setPharmaorderFilterCriteria(
            {
                ...filterCriteria,
                orderstatus:orderstatus
        }))
    }

    return (

        <Grid container direction="row" lg={12} sx={{justifyContent:'center'}}>
                    <Grid item lg={4} padding={1}>
                        <TextField type="search" variant="standard"
                            label="Executivename"
                            name="executivename"
                            value={filterCriteria.executivename}
                            onChange={(e)=>updateExecutivenameCriteria(e.target.value)}
                            sx={{minWidth:'100px'}}
                        />
                    </Grid>

                    <Grid item lg={4} padding={1}>
                        <TextField type="search" variant="standard"
                            label="Partyname"
                            name="partyname"
                            value={filterCriteria.partyname}
                            onChange={(e)=>updatePartynameCriteria(e.target.value)}
                            sx={{minWidth:'100px'}}
                        />
                    </Grid>

                    <Grid item lg={4} padding={1}>
                        <TextField type="search" variant="standard"
                            label="Orderid"
                            name="orderid"
                            value={filterCriteria.orderid}
                            onChange={(e)=>updateOrderidCriteria(e.target.value)}
                            sx={{minWidth:'100px'}}
                        />
                    </Grid>

                    <Grid item padding={1}>
                        <FormControl  style={{minWidth: 250}} size="small">
                        <InputLabel id="ratinginput">Status</InputLabel>
                        <Select
                            labelId="orderstatusselect"
                            id="orderstatus"
                            value={filterCriteria.orderstatus}
                            name="orderstatus"
                            label="Status"
                            onChange={(e)=>updateOrderstatusCriteria(e.target.value)}
                            //defaultValue={orderstatus}
                            >
                            <MenuItem value="">None</MenuItem>
                            
								<MenuItem value="DRAFT">DRAFT</MenuItem>
								<MenuItem value="UNDER APPROVAL">UNDER APPROVAL</MenuItem>
								<MenuItem value="APPROVED">APPROVED</MenuItem>
								<MenuItem value="UNDER DELIVERY">UNDER DELIVERY</MenuItem>
								<MenuItem value="DELIVERED">DELIVERED</MenuItem>
                        </Select>
                    </FormControl>
                    </Grid>


        </Grid>
    )

}